

export class CompanyDetailUpdateMapInput implements ICompanyDetailUpdateMapInput {
    /** The Reference id of the tbl_company_details_map table */
    companyDetailsMapId!: number;
    /** The Reference id of the tbl_company_detail table */
    companyDetailId!: number;
    /** The Reference id of the tbl_map table */
    mapId!: number;
    /** The web map key with 2048 character limit */
    webMapKey!: string;
    /** The map project id with 2048 character limit */
    mapProjectId!: string;
    /** The address from map provider flag must be one of 0 or 1 for available */
    addressFromMapProviderFlag!: number;
    /** The speed limit api must be one of 0 or 1 for available */
    speedLimitApi!: number;
    /** The speed limit api must be one of default 1 else 0 */
    default!: number;

    constructor(data?: ICompanyDetailUpdateMapInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyDetailsMapId = _data["companyDetailsMapId"];
            this.companyDetailId = _data["companyDetailId"];
            this.mapId = _data["mapId"];
            this.webMapKey = _data["webMapKey"];
            this.mapProjectId = _data["mapProjectId"];
            this.addressFromMapProviderFlag = _data["addressFromMapProviderFlag"];
            this.speedLimitApi = _data["speedLimitApi"];
            this.default = _data["default"];
        }
    }

    static fromJS(data: any): CompanyDetailUpdateMapInput {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyDetailUpdateMapInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyDetailsMapId"] = this.companyDetailsMapId;
        data["companyDetailId"] = this.companyDetailId;
        data["mapId"] = this.mapId;
        data["webMapKey"] = this.webMapKey;
        data["mapProjectId"] = this.mapProjectId;
        data["addressFromMapProviderFlag"] = this.addressFromMapProviderFlag;
        data["speedLimitApi"] = this.speedLimitApi;
        data["default"] = this.default;
        return data; 
    }
}

export interface ICompanyDetailUpdateMapInput {
    /** The Reference id of the tbl_company_details_map table */
    companyDetailsMapId: number;
    /** The Reference id of the tbl_company_detail table */
    companyDetailId: number;
    /** The Reference id of the tbl_map table */
    mapId: number;
    /** The web map key with 2048 character limit */
    webMapKey: string;
    /** The map project id with 2048 character limit */
    mapProjectId: string;
    /** The address from map provider flag must be one of 0 or 1 for available */
    addressFromMapProviderFlag: number;
    /** The speed limit api must be one of 0 or 1 for available */
    speedLimitApi: number;
    /** The speed limit api must be one of default 1 else 0 */
    default: number;
}

